import React, { useState } from 'react';
import { Input, Button, Typography } from 'antd';
import './AddCategoryProvider.css';

const { Title } = Typography;

const AddCategoryProvider = () => {
  const [categoryName, setCategoryName] = useState('');

  const handleSave = () => {
    if (categoryName.trim()) {
      console.log('Saving category:', categoryName);
      // Add your save logic here
      setCategoryName(''); // Clear input after save
    }
  };

  return (
    <div className="add-category-provider-container">
      <Title level={3} className="add-category-provider-title">Add Category</Title>
      <div className="add-category-provider-form">
        <Input
          placeholder="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          className="add-category-provider-input"
          size="large"
        />
        <Button
          type="primary"
          onClick={handleSave}
          className="add-category-provider-button"
          size="large"
          disabled={!categoryName.trim()}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default AddCategoryProvider;